module.exports = __webpack_public_path__ + "static/media/48357202_2308767452531766_7742721639682408448_o.060d1935.jpg";